(function () {
  var STORAGE_KEY = 'zidances_intro_seen';

  function hasSeenIntro() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function markIntroSeen() {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {
      /* sessionStorage unavailable (private mode, etc) — overlay still works, just may replay */
    }
  }

  class RoyalIntroOverlay extends HTMLElement {
    connectedCallback() {
      if (hasSeenIntro()) {
        return;
      }

      this.dismissed = false;
      this.maxDuration = parseInt(this.dataset.maxDuration, 10) || 5000;
      this.fadeDuration = parseInt(this.dataset.fadeDuration, 10) || 500;
      this.breakpoint = parseInt(this.dataset.breakpoint, 10) || 749;

      markIntroSeen();

      this.removeAttribute('hidden');
      document.documentElement.classList.add('royal-intro-scroll-lock');

      var isMobile = window.matchMedia('(max-width: ' + this.breakpoint + 'px)').matches;
      var activeWrapper = this.querySelector(
        isMobile ? '.royal-intro__media--mobile' : '.royal-intro__media--desktop'
      );
      this.video = activeWrapper ? activeWrapper.querySelector('video') : this.querySelector('video');
      this.skipButton = this.querySelector('.royal-intro__skip');

      this.boundDismiss = this.dismiss.bind(this);

      if (this.video) {
        this.video.addEventListener('ended', this.boundDismiss);
        this.video.addEventListener('error', this.boundDismiss);

        // preload/autoplay are intentionally off in markup so the inactive
        // device's video never downloads — load and play only the active one.
        this.video.load();
        var playResult = this.video.play();
        if (playResult && typeof playResult.catch === 'function') {
          playResult.catch(function () {
            /* autoplay blocked — the failsafe timer still dismisses the overlay on schedule */
          });
        }
      }

      if (this.skipButton) {
        this.skipButton.addEventListener('click', this.boundDismiss);
      }

      this.failsafeTimer = window.setTimeout(this.boundDismiss, this.maxDuration);
    }

    dismiss() {
      if (this.dismissed) {
        return;
      }
      this.dismissed = true;

      window.clearTimeout(this.failsafeTimer);

      if (this.video) {
        this.video.removeEventListener('ended', this.boundDismiss);
        this.video.removeEventListener('error', this.boundDismiss);
      }
      if (this.skipButton) {
        this.skipButton.removeEventListener('click', this.boundDismiss);
      }

      this.classList.add('is-hiding');
      document.documentElement.classList.remove('royal-intro-scroll-lock');

      var self = this;
      window.setTimeout(function () {
        self.setAttribute('hidden', '');
        if (self.video) {
          self.video.pause();
        }
      }, this.fadeDuration + 50);
    }
  }

  if (!customElements.get('royal-intro-overlay')) {
    customElements.define('royal-intro-overlay', RoyalIntroOverlay);
  }
})();
